import React from "react";
import FeedbackBanner from "../../general/correct-feedback/FeedbackBanner";
import AnswerOption from "../../general/answer-option/AnswerOption";

const TestQuestion = ({
  question,
  options,
  selectedOption,
  optionStatuses,
  onOptionClick,
  showCheckButton,
  canCheck,
  onCheck,
  feedbackVisible,
  feedback,
  onCloseFeedback,
  showNextButton,
  onNext,
  showFinishButton,
  onFinish,
  imgPath,
  videoPath,
  addClass,
}) => {
  return (
    <>
      <div className="test-question" dangerouslySetInnerHTML={{ __html: question || "" }} />

      {!imgPath && !videoPath ? (
        <ul className="answer-options">
          {(options || []).map((option) => (
            <AnswerOption
              key={option.id}
              id={option.id}
              text={option.text}
              selectedOption={selectedOption}
              status={optionStatuses[option.id]}
              onClick={onOptionClick}
            />
          ))}
        </ul>
      ) : (
        <div className="test-content">
          <div className={`c1 ${addClass || ""}`}>
            {imgPath && <img src={imgPath} alt="moduleImg" />}
            {videoPath && (
              <iframe
                width="100%"
                height="100%"
                src={videoPath}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            )}
          </div>
          <div className="c2">
            {Array.isArray(options) && options.length > 0 && (
              <ul className="answer-options">
                {options.map((option) => (
                  <AnswerOption
                    key={option.id}
                    id={option.id}
                    text={option.text}
                    selectedOption={selectedOption}
                    status={optionStatuses[option.id]}
                    onClick={onOptionClick}
                  />
                ))}
              </ul>
            )}
          </div>
        </div>
      )}

      {showCheckButton && canCheck && (
        <button className="btn checkAnswer" onClick={onCheck} style={{ display: "inline-block" }}>
          Перевірити
        </button>
      )}

      {feedbackVisible && <FeedbackBanner feedback={feedback} closeFeedback={onCloseFeedback} />}

      {showNextButton && (
        <button className="btn nextAnswer" onClick={onNext} style={{ display: "inline-block" }}>
          Наступне завдання
        </button>
      )}

      {showFinishButton && (
        <button className="btn nextAnswer" onClick={onFinish} style={{ display: "inline-block" }}>
          Завершити
        </button>
      )}
    </>
  );
};

export default TestQuestion;
